import React from 'react';
import { ArrowRightStartOnRectangleIcon } from '@heroicons/react/24/outline';
import {
    Avatar,
    AvatarColors,
    AvatarShapes,
    AvatarSizes,
    Button,
    ButtonHierarchies,
    ButtonSizes,
    DropdownMenu,
    DropdownMenuPlacements,
} from '@clockout-dev/design-elements';
import { getInitials } from '../../../../utils/initials';
import { HeaderConstants } from '../header.constants';
import styles from '../styles/accountMenu.module.scss';

/**
 * Header account menu — Figma Admin 3.0 «Navbar» avatar (797:54119) and its
 * popover (Variant2, 797:54166): name, email and "Role · Bank", then Log out
 * under a divider. Presentational — user, bank and logout come from Header.
 */
function AccountMenu({ user, fi, role, onLogout }) {
    const name = user?.name;
    const meta = [role, fi].filter(Boolean).join(' · ');

    return (
        <DropdownMenu
            placement={DropdownMenuPlacements.BOTTOM_RIGHT}
            width={HeaderConstants.ACCOUNT_MENU_WIDTH}
            classNames={{ header: styles.info, footer: styles.footer }}
            header={
                <div className={styles.account}>
                    <span className={styles.name}>{name}</span>
                    <span className={styles.email}>{user?.email}</span>
                    {meta ? <span className={styles.meta}>{meta}</span> : null}
                </div>
            }
            footer={
                <Button
                    block
                    hierarchy={ButtonHierarchies.GHOST}
                    size={ButtonSizes.MEDIUM}
                    icon={<ArrowRightStartOnRectangleIcon />}
                    classNames={{ root: styles.logout, icon: styles.logoutIcon, label: styles.logoutLabel }}
                    onClick={onLogout}
                >
                    Log out
                </Button>
            }
        >
            <button type="button" className={styles.trigger} aria-label="Account menu">
                <Avatar
                    initials={getInitials(name)}
                    alt={name}
                    color={AvatarColors.BRAND_SUBTLE}
                    shape={AvatarShapes.CIRCLE}
                    size={AvatarSizes.COMPACT}
                />
            </button>
        </DropdownMenu>
    );
}

export default AccountMenu;
